import {
  packStringsForAPI,
  unpackStringsForUI,
} from '@/sections/insights/queryBuilder/entities/common/multiValueHelpers';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import { fetchRiskTags } from '@/sections/insights/queryBuilder/entities/utils/fieldValues';
import type { QueryFilter } from '@/types';

const operatorMap: Record<string, string> = {
  IN: 'contains',
};

const operatorMapInverse: Record<string, string> = {
  contains: 'IN',
};

/**
 * Reusable field definition for Risk tags
 * Dynamically fetches available tags from API
 */
export const RiskTags: SimpleFilterDefinition = {
  apiField: 'tags',
  uiField: 'Tags',
  inputType: 'dropdown',
  getAvailableValues: fetchRiskTags,
  // Risk.Tags is the only place the internal hunt/agent/cato provenance tags
  // are written — hide them from customer dropdown values (ENG-4525).
  maskInternalTags: true,
  operators: ['contains', 'does not contain'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    const operator = getOperatorFromQueryFilter(queryFilter, operatorMap);
    const unpacked = unpackStringsForUI(queryFilter.value, operator);

    return {
      field: 'Tags',
      operator,
      value: unpacked,
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const apiValue = packStringsForAPI(
      simpleFilter.value as string | string[],
      simpleFilter.operator
    );

    return {
      field: 'tags',
      operator: getOperatorFromSimpleFilter(simpleFilter, operatorMapInverse),
      value: apiValue,
      not: getNotFromSimpleFilter(simpleFilter),
      reverseOperands: true,
    };
  },
};
